// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"df106e3c","122":"f1bb2572","139":"21263406","165":"8dc33fab","453":"1f114cfe","655":"eccd3dbd","776":"9a25e2f5","794":"09f6c2b0"}[chunkId] + ".chunk.js";
};